(ns frontend.ui.component.lp-portal.report.company.financials-chart.view
  (:require
   [frontend.ui.component.chart.view :refer [chart]]
   [frontend.ui.component.lp-portal.card.view :refer [card]]
   [frontend.ui.component.lp-portal.text-content.view :as text-content]))

(defn financials-chart
  [financials props]
  [card
   {:title "Financials"}
   [:<>
    [chart financials props]
    (text-content/optional-footnote financials props)]])
